import React, { useState, useContext } from 'react';
import BlockForm from '@berlitz/blocks/lib/BlockForm';
import { fields as formFields } from './fields';
import axios from 'axios';
import FormModal from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/components/SliceForm/FormModal';
import getRecaptchaToken from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/functions/getRecaptchaToken';
import ConfigContext from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/contexts/ConfigContext';
import { getSerializedHTML, getBackgroundColor } from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/functions/utils';
import getValuesFromWindow from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/functions/getValuesFromWindow';
import mapFormValuesToPostBodyModularBlockForm from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/functions/mapFormValuesToPostBodyModularBlockForm.js';
import { SliceWrapper } from '@berlitz/gatsby-theme-blitz-prismic-franchise/src/components/SliceWrapper';

const Form = ({ primary, lang, pageLinks }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [isError, setIsError] = useState(false)
  const formReference = primary.form_type.document.data || {}
  const formTitle = formReference?.form_title || ''
  const formSubtitle = formReference?.form_subtitle?.html || ''
  const formButton = formReference?.submit_button || ''
  const { fields, fieldsHidden } = formFields(lang)
  const additionalFields = formReference?.body || []
  const additionalFieldsFormatted = additionalFields.map((field, index) => ({
    type: 'text',
    width: field.primary.field_width,
    label: field.primary.field_label,
    required: true,
    autocompleteAttribute: 'none',
    name: field.primary.field_label || 'unnamed_field_' + index,
  }))
  let windowValuesHiddenFields = []
  if (typeof window !== `undefined`) {
    const windowValues = getValuesFromWindow(window.location)
    windowValuesHiddenFields = Object.keys(windowValues).map(key => ({
      name: key,
      value: windowValues[key],
    }))
  }
  const handleClose = () => setModalOpen(false)
  const { recaptchaKey } = useContext(ConfigContext)

  const resetFormFields = () => {
    if (typeof window.formikSetFieldValue !== 'function') return
    const allFields = [...fields, ...additionalFieldsFormatted]
    Array.isArray(allFields) &&
      allFields.forEach(field => {
        const fieldName = field?.name
        const fieldType = field?.type
        const defaultValue = field?.defaultValue
        if (fieldType === 'checkbox') {
          const checkedDefaultValue = field?.checkedByDefault ? '1' : '0'
          window.formikSetFieldValue(fieldName, checkedDefaultValue)
        } else {
          window.formikSetFieldValue(fieldName, defaultValue || '')
        }
      })
  }
  const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
  const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
  return (
    <div id="form">
    <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}>

      <BlockForm
        enableReinitialize
        action="https://api.berlitz.tech/v2/forms"
        submitLabel={formButton}
        fields={[...fields, ...additionalFieldsFormatted]}
        backgroundColor={getBackgroundColor(primary.section_background_color)}
        hiddenFields={[...fieldsHidden, ...windowValuesHiddenFields]}
        title={formTitle}
        subtitle={formSubtitle}
        onSubmit={(values, setSubmitting) => {
          getRecaptchaToken(recaptchaKey).then(recaptchaToken => {
            values.google_recaptcha_token = recaptchaToken
            axios({
              method: 'POST',
              url: `https://api.berlitz.tech/v2/forms`,
              data: JSON.stringify(
                mapFormValuesToPostBodyModularBlockForm(values)
              ),
              headers: { 'Content-Type': 'application/json' },
            })
              .then(() => {
                resetFormFields()
                setModalOpen(true)
                setSubmitting(false)
              })
              .catch(() => {
                setIsError(true)
                setModalOpen(true)
                setSubmitting(false)
              })
          })
        }}
      />
      <FormModal
        open={modalOpen}
        modalContent={getSerializedHTML(
          isError ? primary.error_modal.richText : primary.thank_modal.richText,
          pageLinks
        )}
        handleClose={handleClose}
      />
      </SliceWrapper>
    </div>
  )
}

export default Form;
